module.exports = __webpack_public_path__ + "img/1f9ae.32d4141.svg";